import React, {Component} from 'react';
import {Api} from '../../api';
import TextFieldInput from '../../components/Common/TextFieldInput'
import SelectInput from '../../components/Common/SelectInput'
import ButtonInput from '../../components/Common/ButtonInput'
import {checkAuth, getAuthToken} from '../../utils';
import {connect} from 'react-redux';
import './Transactions.scss';
import TransactionHistory from "../../components/TransactionHistory";

const TRANSACTIONS_MODE = {
    SELECT_MODE: 'select',
    CREATE_TRANSACTION: 'create',
    PROOF_TRANSACTION: 'proof',
};

class Transactions extends Component {

    state = {};

    componentDidUpdate(prevProps) {
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentWillMount() {
        this.props.handleLoader(true);
    }

    componentDidMount() {
        this.props.handleLoader(false);
    }

    setTransactionMode = (mode) => {
        this.props.history.push(`/user/transactions/${mode}`);
    };

    render() {
        return (
            <div className='content-wrapper'>
                <div className={`content m-b-16 h-400`}>
                    <div className="content-h2">Transactions</div>
                    <div className="hr-content"/>
                        <div className="content-body select-mode transaction-block">
                            <ButtonInput
                                width='250'
                                size='huge'
                                className={`dark-button transparent-btn-black m-r-30`}
                                title='Create a transaction'
                                handleClick={() => this.setTransactionMode(TRANSACTIONS_MODE.CREATE_TRANSACTION)}/>
                            <ButtonInput
                                width='250'
                                size='huge'
                                className={`dark-button transparent-btn-black`}
                                title='Declare transaction'
                                handleClick={() => this.setTransactionMode(TRANSACTIONS_MODE.PROOF_TRANSACTION)}/>
                        </div>
                </div>
                <TransactionHistory/>
            </div>
        )
    }

    onCreateTransaction = () => {
        const {
            balance, entity, digitalSignature, digitalSignatures, walletFrom, walletTo, walletsFrom, recipient,
            recipients, walletsTo, companyId, mode, transactionId, entitySender, entityRecipient, entitiesSender,
            entitiesRecipient, description, digitalSignaturesRecipient
        } = this.state;

        this.props.handleLoader(true);
        const authToken = getAuthToken();
        console.log(this.state, 'this.state');
        const walletsFromId = walletsFrom.map(wallet => wallet.id);
        const walletsToId = walletsTo.map(wallet => wallet.id);
        const data = {
            transactionId: transactionId,
            userCompany: mode === TRANSACTIONS_MODE.CREATE_TRANSACTION ? companyId :
                (entitySender !== null ? entitiesSender[entitySender].id : null),
            digitalSignatureId: mode === TRANSACTIONS_MODE.CREATE_TRANSACTION ? digitalSignatures[digitalSignature].id :
                ((typeof digitalSignature !== 'string' && entitySender !== null) ? digitalSignatures[digitalSignature].id : digitalSignaturesRecipient[digitalSignature].id),
            senderWalletIds: mode === TRANSACTIONS_MODE.CREATE_TRANSACTION ? walletsFrom[walletFrom].id : walletsFromId,
            amount: balance,
            recipientCompanyId: mode === TRANSACTIONS_MODE.CREATE_TRANSACTION ? recipients[recipient].id :
                (entityRecipient !== null ? entitiesRecipient[entityRecipient].id : null),
            recipientWalletIds: mode === TRANSACTIONS_MODE.CREATE_TRANSACTION ? walletsTo[walletTo].id : walletsToId,
            description: description
        };
        console.log(data, 'data');

        Api.post(`transaction`, data, authToken).then((response) => {

            console.log(response, 'response wallets');

            this.props.history.push(`/user/transaction/${response.data.id}`);

            setTimeout(() => this.props.handleLoader(false), 200)
        }).catch((error) => {
            setTimeout(() => this.props.handleLoader(false), 200);
            checkAuth(error, this.props.history);
            console.log(error, 'error')
        });
    }

}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(Transactions);


// WEBPACK FOOTER //
// ./src/views/Transactions/Transactions.js